// extracted by mini-css-extract-plugin
export default {"NoDataPoints":"NoDataPoints_NoDataPoints__WO9Vv"};